import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import Input from "components/Elements/Input";
import Select from "react-select";
import { titleCase } from "../../utils/utils"
import { saveClient, getClient } from "actions/clients";
import { getPlatformFeatures } from "services/platform";
import styled from "styled-components";
import Checkbox from "components/Elements/Checkbox";
import UsersTable from "components/Tables/UsersTable";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const Client = ({ navigation }) => {
  const navigate = useNavigate();
  const { client_id } = useParams();
  const dispatch = useDispatch();
  const { client, saving } = useSelector((state) => state.clients);
  const [localClient, setLocalClient] = useState(client);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(true);

  const themeOptions = [
    { label: "Default", value: "default" },
    { label: "Dark", value: "dark" },
    { label: "Auto", value: "auto" }
  ]

  const [platformFeatures, setPlatformFeatures] = useState([]);

  useEffect(() => {
    if (client_id && (client === null || localClient === null)) {
      setLoading(true);
      dispatch(getClient(client_id));
    } else if (!client_id) {
      setLoading(false);
      setLocalClient(null);
    }

    const fetchPlatformFeatures = async () => {
      const features = await getPlatformFeatures();
      setPlatformFeatures(features);
    };

    fetchPlatformFeatures();

    return () => {
      setLocalClient(null);
      setLoading(true);
    };
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (client_id) {
      setLoading(true);
      dispatch(getClient(client_id));
    } else {
      setLoading(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client_id]);

  useEffect(() => {
    if (client && client_id === client.public_id) {
      setLoading(false);
      setLocalClient({ ...client });
      console.log(client.users);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client]);

  useEffect(() => {
    if (!localClient || !localClient.users) return;


    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localClient]);



  if (loading) {
    return (
      <div>
        <div style={{ marginLeft: "50px" }}>Loading Client...</div>
      </div>
    );
  }

  const handleChange = ({ target }) => {
    const u = { ...client };
    u[target.name] = target.value;
    setLocalClient(u);
  };

  const validateFields = () => {
    setFormErrors({});
    const errors = {};

    const clientNameValid = localClient.name && localClient.name.length > 0;
    errors.Name = clientNameValid ? "" : " is required";

    console.log("errors: ", errors);
    setFormErrors(errors);

    return clientNameValid;
  };

  const save = () => {
    if (validateFields()) {
      dispatch(saveClient(localClient));
    }
  };

  const handleThemeChange = (theme) => {
    const c = { ...localClient };
    c.theme = theme.value;
    setLocalClient(c);
  };

  const FeatureList = () => {
    return (
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", maxWidth: "600px" }}>
        {platformFeatures.map(f => {
          return (
            <div key={`feature_${f.id}`} style={{ marginRight: "20px", marginBottom: "20px", width: "160px" }}>
              <Checkbox
                label={titleCase(f.feature_name)}
                placeholder={f.feature_name}
                name={f.feature_name}
                value={f.id}
                checked={localClient?.features?.find(cf => cf.id === f.id)}
                onChange={({ target }) => {
                  console.log("!! CHECKBOX: ", f.feature_name, target.type, target.checked)
                  const updatedClient = { ...localClient };
                  if (target.checked) {
                    updatedClient.features.push({
                      "id": f.id,
                      "name": f.feature_name
                    });
                  } else {
                    updatedClient.features = updatedClient.features.filter(cf => cf.id !== f.id)
                  }
                  setLocalClient(updatedClient);
                }}
              />
            </div>
          )
        }
        )
        }
      </div>);
  }

  return (
    <div>
      <div className="relative p-6 flex-auto ">
        <div>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate("/admin/clients");
            }}
          >
            <i className="fa fa-arrow-left" /> Back to Clients
                </div>{" "}
        </div>
        <h3 className="text-3xl font-semibold">
          {localClient?.id ? "Edit Client" : "Add Client"}
        </h3>
        <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
          <label>ID</label>
          <Input
            label="ID"
            placeholder="ID"
            name="id"
            value={localClient?.id ?? ""}
            disabled
          />
          <label>Public ID</label>
          <Input
            label="Public ID"
            placeholder="Public ID"
            name="public_id"
            value={localClient?.public_id ?? ""}
            disabled
          />
          <label>
            Name <ErrorField>{formErrors.name}</ErrorField>
          </label>
          <Input
            label="Name"
            placeholder="Name"
            name="name"
            value={localClient?.name ?? ""}
            onChange={handleChange}
          />
          <label>
            Theme <ErrorField>{formErrors.theme}</ErrorField>
          </label>
          <Select
            label="Theme"
            placeholder="Theme"
            name="theme"
            value={
              localClient?.theme !== null
                ? themeOptions.find(
                  (c) =>
                    localClient?.theme &&
                    c.value === localClient?.theme
                )
                : "default"
            }
            options={themeOptions}
            onChange={handleThemeChange}
          />
        </div>
      </div>
      <div style={{ marginLeft: "20px" }}>
        <FeatureList />
      </div>
      <div className="relative p-6 flex-auto"></div>
      {/*footer*/}
      <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
        <button
          className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
          type="button"
          onClick={save}
          disabled={saving}
        >
          {saving ? (
            <>
              <i className="fas fa-circle-notch fa-spin"></i> Saving...
                  </>
          ) : (
            <>Save Changes</>
          )}
        </button>
      </div>
      <div>
        <UsersTable users={localClient.users} />
      </div>
    </div>
  );
};

export default Client;
